<template>
  <div class="pad-cycle-filters">
    <div class="pad-cycle-toggle" @click="showPadCycle = !showPadCycle">
      <i
        :class="showPadCycle ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
        class="toggle-icon"
      ></i>
    </div>
    <div v-if="showPadCycle" class="pad-cycle-section">
      <PadCycleLookUp />
      <PadCycleLookUpWithId v-if="showPadCycleIdFilter" />
    </div>
  </div>
</template>

<script>
import PadCycleLookUp from '@/components/pods/chartData/PadCycleLookUp'
import PadCycleLookUpWithId from '@/components/pods/chartData/PadCycleLookUpWithId'
export default {
  props: {
    showPadCycleIdFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPadCycle: false
    }
  },
  components: {
    PadCycleLookUp,
    PadCycleLookUpWithId
  }
}
</script>

<style lang="scss" scoped>
.pad-cycle-filters {
}
</style>
